import * as React from 'react';
import { acquireTokenRefresh, releaseTokenRefresh } from 'utils/auth/tokenRefreshScheduler';

/**
 * Keeps the dealer authenticated across the working day by silently refreshing the access
 * token shortly before it expires. Mounted once at the app root; the loop itself is a
 * page-wide singleton in {@link acquireTokenRefresh}, so extra mounts never start a second one.
 */
export function useTokenRefresh(): void {
  React.useEffect(() => {
    acquireTokenRefresh();
    return releaseTokenRefresh;
  }, []);
}
